export function isObject(value) {
  const type = typeof value

  return (
    value != null &&
    (type === 'object' || type === 'function') &&
    !Array.isArray(value)
  )
}

export function isEmpty(value) {
  if (Array.isArray(value)) return value.length === 0
  if (isObject(value)) return Object.keys(value).length === 0
  if (value == null || value === '') return true
  return false
}

export function omit(object, keys) {
  const result = {}

  Object.keys(object).forEach(key => {
    if (keys.includes(key)) return
    result[key] = object[key]
  })

  return result
}

export function pick(object, keys) {
  const result = {}

  keys.forEach(key => {
    if (key in object) {
      result[key] = object[key]
    }
  })

  return result
}
